export const DEFAULT_MEME_TEXT = `TEXT HERE`;
